<template>
    <div class="is-flex">
        <!-- <div class="py-3 px-1 is-flex is-flex-direction-column is-justify-content-space-between">
            <img class="tile-dot-img" :src="require('@/assets/images/icons/analytics/dot-1.svg')" />
            <img class="tile-dot-img" :src="require('@/assets/images/icons/analytics/dot-1.svg')" />
        </div> -->
        <div :style="`background-color: ${backgroundColor};`" class="analytics-summary-tile">
            <img class="tile-icon" :src="icon">
            <div class="is-block is-flex-grow-1">
                <p class="subtitle is-6">{{title}}</p>
                <p class="title is-4">{{value}}</p>
            </div> 
        </div>
        <!-- <div class="py-3 px-1 is-flex is-flex-direction-column is-justify-content-space-between">
            <img class="tile-dot-img" :src="require('@/assets/images/icons/analytics/dot-1.svg')" />
            <img class="tile-dot-img" :src="require('@/assets/images/icons/analytics/dot-1.svg')" />
        </div> -->
    </div>
</template>
<script>
export default{
    name : 'summary-tile',
    props : {
        title : {
            type : String,
            required : true
        },
        value : {
            required : true
        },
        icon : {
            type : String,
            required : true
        },
        backgroundColor : {
            type : String,
            required : true
        },
    }
}
</script>
<style scoped>
.tile-dot-img{
    width: 20px;
    min-width: 20px;
}
.analytics-summary-tile{
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 20px 10px;
}

.analytics-summary-tile > .tile-icon{
  height: 50px;
}
</style>